var EnvNgApp;
(function (EnvNgApp) {
    var Core;
    (function (Core) {
        var Helpers;
        (function (Helpers) {
            var LoadingIndicatorHelper = /** @class */ (function () {
                function LoadingIndicatorHelper() {
                }
                LoadingIndicatorHelper.setLoadingIndicator = function (element, show) {
                    element.css("position", "relative");
                    kendo.ui.progress(element, show);
                    if (show) {
                        element.find(".k-loading-mask").css("z-index", 2);
                    }
                };
                return LoadingIndicatorHelper;
            }());
            Helpers.LoadingIndicatorHelper = LoadingIndicatorHelper;
        })(Helpers = Core.Helpers || (Core.Helpers = {}));
    })(Core = EnvNgApp.Core || (EnvNgApp.Core = {}));
})(EnvNgApp || (EnvNgApp = {}));
//# sourceMappingURL=loadingindicatorhelper.js.map